<template>
  <v-container class="fill-height eservice_type" fluid>
    <v-layout column class="eservice_inner_wrap">
      <h2 class="outside_title d-flex">
        {{ $t('myrequest.title') }}
        <Bookmark service_type_code='6432' />

        <v-spacer></v-spacer>
        <span class="loc_postion">
            <span class="front_loc">{{ $t('myrequest.title') }} > </span>
            <span class="back_loc">{{ $t('common.common.list') }}</span>
        </span>
      </h2>
      <v-layout column class="ma-0 pos-r center__wrapper">
        <v-flex class="inner_basic_wrap type2">
          <div class="top__component__fold__wrap" v-if="component_fold">
            <v-row class="top_search_content2 type2">
              <v-col cols="12" md="4">
                <label class="nec_title">{{ $t('myrequest.list.fields.request_service') }}</label>
                <v-select
                  dense
                  solo
                  flat
                  outlined
                  hide-details
                  :items="$vuetify.rtl ? serviceListAr : serviceListEn"
                  v-model="search_service_type_code"
                >
                </v-select>
              </v-col>

              <v-col cols="12" md="4">
                <label class="nec_title">{{ $t('myrequest.list.fields.status') }}</label>
                <v-select
                  dense
                  solo
                  flat
                  outlined
                  hide-details
                  :items="$vuetify.rtl ? statusListAr : statusListEn"
                  v-model="search_receipt_status_type_code"
                >
                </v-select>
              </v-col>

              <v-col cols="12" md="4">
                <label class="nec_title">{{ $t('myrequest.list.fields.request_date') }}</label>
                <v-menu ref="menu1" v-model="menu" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" in-width="290px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      outlined
                      solo
                      dense
                      flat
                      placeholder="DD/MM/YYYY"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      hide-details
                      append-icon="mdi-calendar"
                      class="date_type ft-size12"
                      v-model="search_request_date"
                      @click:append="menu = true"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="date" no-title @input="menu = false"></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>

            <v-row class="top_search_content2 type2">

              <v-col cols="12" md="4">
                <label class="nec_title">{{ $t('myrequest.list.fields.receiving_no') }}</label>
                <v-text-field
                  dense
                  solo
                  flat
                  hide-details
                  outlined
                  placeholder=""
                  v-model="search_receipt_no"
                >
                </v-text-field>
              </v-col>

              <v-col cols="12" md="4" class="d-flex flex-end d_clmn">
                <div class="wp100">
                  <label class="nec_title">{{ $t('myrequest.list.fields.application_no') }}</label>
                  <v-text-field
                    dense
                    solo
                    flat
                    hide-details
                    outlined
                    placeholder=""
                    v-model="search_application_no"
                  >
                  </v-text-field>
                </div>
              </v-col>
              <v-col cols="12" md="4" class="d-flex flex-end d_clmn">
                <v-btn
                  class="t_search_btn wp50"
                  color="#a01c2a"
                  dark
                  @click="fnGetDataFromApi(1)"
                >
                  <v-icon>mdi-magnify</v-icon><v-spacer class="hidden_lr2"></v-spacer>
                  {{ $t('common.button.search') }}
                </v-btn>
                <v-spacer class="hidden_lr5"></v-spacer>
                <v-btn
                  class="t_search_btn wp50"
                  color="#222"
                  dark
                  @click="fnReset()"
                >
                  <v-icon>mdi-restart</v-icon><v-spacer class="hidden_lr2"></v-spacer>
                  {{ $t('common.button.reset') }}
                </v-btn>
              </v-col>
            </v-row>
          </div>


          <!-- 상단 레이아웃 접는 기능영역 : S -->
          <div class="fold__actions__wrap">
            <v-btn @click="foldingActions()" :class="{actv : component_fold}" color="#dedede" small min-width="120px"><v-icon x-small color="#727272">mdi-triangle</v-icon></v-btn>
          </div>
          <!-- 상단 레이아웃 접는 기능영역 : E -->

          <v-row class="ma-0 mt-30">
            <v-col cols="12" class="pa-0">
              <v-data-table
                :custom-sort="$customSort"
                :headers="$getHeaderType2(headerTxt, headers_en, headers_ar)"
                :items="requestList"
                hide-default-footer
                class="new__type__table"
                :options.sync="options"
                :server-items-length="paging.totalCount"
                mobile-breakpoint="0"
              >
                <template v-slot:item="{ item }">
                  <tr>
                    <td @click="fnGoDetail(item)" style="cursor:pointer;">{{ item.receipt_no }}</td>
                    <td>
                      <span>{{ item.application_no }}</span>
                      <v-badge :content="'+'+ (item.application_cnt - 1)"
                        v-if="item.application_cnt > 1"
                        class="pl-1 badge__new"
                        style="margin-left:5px;"
                      ></v-badge>
                      <p v-if="item.request_service_code === '1005' && !(item.application_no)" style="color:#a01c2a;font-weight:bold;">({{ item.application_receipt_no }})</p>
                    </td>
                    <td @click="fnGoDetail(item)" style="cursor:pointer;">{{ item.request_date }}</td>
                    <td @click="fnGoDetail(item)" style="cursor:pointer;">
                      <span v-if="item.service_type_code === '6420' && (item.certified_type_name_en)">{{ $vuetify.rtl ? item.certified_type_name_ar : item.certified_type_name_en }}</span>
                      <span v-else>{{ $vuetify.rtl ? item.request_name_ar : item.request_name_en }}</span>
                    </td>
                    <td>
                      <v-chip
                        :color="getColor(item.receipt_status_type_code)"
                        dark
                        class="ma-2 inner_chip type3"
                        @click="fnGoDetail(item)" style="cursor:pointer;"
                      >
                        {{ $vuetify.rtl ?  item.status_name_ar : item.status_name_en }}
                      </v-chip>
                      <v-btn icon small @click="fnRequestDeleteConfirm(item.receipt_no)" v-if="item.receipt_status_type_code == '4301'">
                        <v-icon small>mdi-close</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </template>
              </v-data-table>

              <div class="v-data-table board_basic_wrap theme--light mb-30">
                <div class="v-data-table-footer page_nation_wrap mt-20">
                  <ServerPagination
                    :paging.sync="paging"
                    @page="fnGoPage"
                    @pageSize="fnSetPageSize"
                  />
                </div>
              </div>
            </v-col>
          </v-row>
        </v-flex>
      </v-layout>
    </v-layout>
    <confirm-dialog
      :id="id"
      @delete="fnDeleteRequest"
    />
  </v-container>
</template>

<script>
import requestApi from '@/utils/requestApi'
import utils from '@/utils/utils'
import eventBus from '@/utils/eventBus'
import ServerPagination from '@/components/layout/ServerPagination'
import ConfirmDialog from '@/components/layout/ConfirmDialog'
import Bookmark from '@/components/layout/Bookmark'

export default {
  name: 'MyReqeustList',
  components :{
    Bookmark,
    ServerPagination,
    ConfirmDialog
  },
  data () {
    return {
      component_fold : false,
      id: 'MyReqeustList',
      paging: {
        page: 1,
        pageSize: 10,
        pageCount: 0,
        totalCount: 0
      },
      options: {},

      //datepicker용
      menu : false,
      date: new Date().toISOString().substr(0, 10),

      serviceListEn: [{ text : 'All', value : ''}],
      serviceListAr: [{ text : 'جميع', value : ''}],
      statusListEn: [{ text : 'All', value : ''}],
      statusListAr: [{ text : 'جميع', value : ''}],

      //검색폼
      search_service_type_code : '',
      search_receipt_no : '',
      search_application_no : '',
      search_receipt_status_type_code : '',
      search_request_date : '',

      headerTxt : {
        prefix : 'myrequest.list.fields.',
        txt : [ 'receiving_no','application_no','request_date','request','status' ]
      },
      headers_ar: [
        { text: 'Receiving No.', align: 'center', value: 'receipt_no', width: '150' },
        { text: 'Application No.', align: 'right', value: 'application_no', width: '180' },
        { text: 'Request Date', align: 'center', value: 'request_date', width: '100' },
        { text: 'Request', align: 'center', value: 'request_name_ar' },
        { text: 'Status', align: 'center', value: 'status_name_ar', width: '150' }
      ],
      headers_en: [
        { text: 'Receiving No.', align: 'center', value: 'receipt_no', width: '150' },
        { text: 'Application No.', align: 'left', value: 'application_no', width: '180' },
        { text: 'Request Date', align: 'center', value: 'request_date', width: '100' },
        { text: 'Request', align: 'center', value: 'request_name_en' },
        { text: 'Status', align: 'center', value: 'status_name_en', width: '150' }
      ],

      requestList : [],

      requestItem : {
        seq: '',
        receipt_no: '',
        application_no: '',
        request_date: '',
        receipt_step: '',
        request_service_code: '',
        request_name_ar: '',
        request_name_en: '',
        status_name_ar: '',
        status_name_en: ''
      },

      searchParams: {}

    }
  },

  watch: {
    date () {
      this.search_request_date = this.formatDate(this.date)
    },
    options: {
      handler () {
        this.fnGetDataFromApi()
      },
      deep: true,
    },
  },
  mounted(){
    window.scrollTo(0, 0)
    // 폴딩 브라우저 사이즈 체크 하여 접고 여는 부분 체크
    this.onResize()
    //window.addEventListener('resize', this.onResize, { passive: true })

    //넘겨받은 쿼리스트링을 검색 파라메터에 삽입
    let param = utils.qryStrToJson(location.href)
    if(param){
      let keys = Object.keys(param)
      for (let i = 0; i < keys.length; i++) {
        this[keys[i]] = param[keys[i]]

        if (keys[i] === 'page') {
          this.options.page = (param[keys[i]]) ? parseInt(param[keys[i]], 10) : 1
        } else if (keys[i] === 'page_size') {
          this.options.itemsPerPage = (param[keys[i]]) ? parseInt(param[keys[i]], 10) : 10
        } else if (keys[i] === 'sort_by') {
          if (param[keys[i]]) {
            this.options.sortBy[0] = param[keys[i]]
          }
        } else if (keys[i] === 'sort_desc') {
          if (param[keys[i]]) {
            this.options.sortDesc[0] = param[keys[i]]
          }
        }
      }
    }

    this.fnInit()
  },
  beforeDestroy (){
    // 리사이징 이벤트 제거
    if (typeof window === 'undefined') {
      return
    }
    //window.removeEventListener('resize', this.onResize, { passive: true });
  },
  methods: {
    onResize () {
      this.component_fold = window.innerWidth < 960 ? false : true
    },
    foldingActions(){
      this.component_fold = !this.component_fold
    },
    fnInit() {
      let options = {
        upper_code: '4300',
        all: true,
        remove: [
          {code : '4302'},
          {code : '4304'},
          {code : '4307'},
          {code : '4309'},
          {code : '4310'}
        ]
      }
      utils.fnGetCodeList(options).then(list => {
        this.statusListAr = list.ar
        this.statusListEn = list.en
      })

      this.getServiceList()
    },
    getServiceList(){
      requestApi({
        url: '/workflow/services',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {

            res.data.list.forEach(item => {
              let service_en = {
                text : item.name_en,
                value : item.service_type_code
              }
              this.serviceListEn.push(service_en)

              let service_ar = {
                text : item.name_ar,
                value : item.service_type_code
              }
              this.serviceListAr.push(service_ar)
            })

          } else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.getServiceList()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },

    fnReset(){
      this.search_service_type_code = ''
      this.search_receipt_no = ''
      this.search_application_no = ''
      this.search_receipt_status_type_code = ''
      this.search_request_date = ''

      this.options.sortBy = []
      this.options.sortDesc = []

      this.searchParams = {}

      if (this.options.page === 1 && this.options.itemsPerPage === 10) {
        this.fnGetDataFromApi(1)
      } else {
        this.options.page = 1
        this.options.itemsPerPage = 10
      }
    },

    fnGoPage(paging) {
      this.options.page = paging.page
    },

    fnSetPageSize(paging) {
      // 페이지당 목록 개수를 변경할 경우에는 1페이지로 이동
      this.options.page = 1
      this.options.itemsPerPage = paging.pageSize
    },

    fnGetDataFromApi (page) {
      if (page) {
        this.options.page = page
        if (page === 1) {
          this.searchParams = {}
        }
      }
      this.fnSearch().then(list => {
        this.requestList = list
        this.paging.totalCount = 0
        if (list.length > 0) {
          this.paging.totalCount = list[0].total_cnt
        }
        this.paging.pageCount = parseInt((this.paging.totalCount - 1) / this.options.itemsPerPage, 10) + 1
      }).catch(() => {
        this.searchParams = {}
        this.fnGetDataFromApi(page)
      })
    },

    fnSearch() {
      return new Promise((resolve, reject) => {
        const { sortBy, sortDesc, page, itemsPerPage } = this.options

        this.paging.page = this.options.page

        let params = {
          search_service_type_code: this.search_service_type_code,
          search_receipt_no: this.search_receipt_no,
          search_application_no: this.search_application_no,
          search_receipt_status_type_code: this.search_receipt_status_type_code,
          search_request_date: this.search_request_date,
          page: this.options.page,
          page_size: this.options.itemsPerPage,
          sort_by: (this.options.sortBy.length > 0) ? this.options.sortBy[0] : '',
          sort_desc: (this.options.sortDesc.length > 0) ? this.options.sortDesc[0] : ''
        }

        if (Object.entries(params).toString() === Object.entries(this.searchParams).toString()) {
          return false
        }

        this.searchParams = params
        requestApi({
          url: '/receivings',
          method: 'GET',
          data: params,
          callback: (res) => {
            if (res.res_code === '200') {
              resolve(res.data.list)
            }else{
              if (res.res_code === '401012') {
                utils.setTokenRefresh().then(() => {
                  reject()
                })
              } else {
                eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
              }
            }
          }
        })
      })
    },
    fnRequestDeleteConfirm(receipt_no){
      let options = {
        title: this.$t('common.message.delete.confirm.title'),
        text: this.$t('common.message.delete.confirm.text'),
        yes: {
          text: this.$t('common.button.yes'),
          event: 'delete',
          callback: {
            receipt_no: receipt_no
          }
        },
        no: {
          text: this.$t('common.button.no')
        }
      }
      eventBus.$emit('SHOW_CONFIRM_DIALOG'+ this.id, options)
    },
    fnDeleteRequest(obj){
      let params = {
        receipt_nos: []
      }
      params.receipt_nos.push(obj.receipt_no)

      requestApi({
        url: '/receivings',
        method: 'DELETE',
        data : params,
        callback: (res) => {
          if (res.res_code === '200') {
            eventBus.$emit('CLOSE_CONFIRM_DIALOG'+ this.id)
            let snackBarOptions = {
              text: this.$t('common.message.delete.success')
            }
            eventBus.$emit('SHOW_SNACKBAR', snackBarOptions)

            this.fnGetDataFromApi(1)
          } else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnDeleteRequest(obj)
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },

    fnGoDetail(item){
      if(item.receipt_status_type_code === '4301' || item.receipt_status_type_code === '4303'){
        // Draft(4301) 인 경우 각 업무별 작성 단계 페이지로 넘긴다
        // await payment (4303) 인 경우 public service 들은 payment 목록으로 이동시킨다.
        // 단, Certified Copy Service (6420), Research service (6417), Translation and audit (6419) 는 제외
        if (item.receipt_status_type_code === '4303'
          && item.service_group_type_code === '4405'
          && item.service_type_code !== '6420'
          && item.service_type_code !== '6417'
          && item.service_type_code !== '6419') {
          this.$router.push('/payment/list')
          return
        }

        // 1001 Temporary protection
        if(item.service_type_code === '6401'){
          let url = '/application/temporaryprotection/step' + item.receipt_step + '/' + item.receipt_no
          this.$router.push(url)
        }

        // 1002 Patent
        if(item.service_type_code === '6402'){
          let url = '/application/patent/step' + item.receipt_step + '/' + item.receipt_no
          this.$router.push(url)
        }

        // 1003 Utility model
        if(item.service_type_code === '6403'){
          let url = '/application/utilitymodel/step' + item.receipt_step + '/' + item.receipt_no
          this.$router.push(url)
        }

        // 1004 IC topography
        if(item.service_type_code === '6404'){
          let url = '/application/ictopography/step' + item.receipt_step + '/' + item.receipt_no
          this.$router.push(url)
        }

        // 1005	Submit missing document
        if(item.service_type_code === '6405'){
          let url = '/myapplication/submitmissingdocument/step' + item.receipt_step + '/' + item.receipt_no
          this.$router.push(url)
        }

        // 1006	Submit amendment
        if(item.service_type_code === '6406'){
          let url = '/myapplication/submitamendment/step' + item.receipt_step + '/' + item.receipt_no
          this.$router.push(url)
        }

        // 1007	Request voluntary amendment
        if(item.service_type_code === '6407'){
          let url = '/modification/voluntaryamendment/step' + (item.receipt_step + 1) + '/' + item.receipt_no
          this.$router.push(url)
        }

        // 1008	Request change name or address
        if(item.service_type_code === '6408'){
          let url = '/modification/changenameaddress/step' + (item.receipt_step + 1) + '/' + item.receipt_no
          this.$router.push(url)
        }

        // 1009	Request change ownership
        if(item.service_type_code === '6409'){
          let url = '/modification/changeownership/step' + (item.receipt_step + 1) + '/' + item.receipt_no
          this.$router.push(url)
        }

        // 1010	Request assign or change agen
        if(item.service_type_code === '6410'){
          let url = '/modification/assignchangeagent/step' + (item.receipt_step + 1) + '/' + item.receipt_no
          this.$router.push(url)
        }

        // 1011	Request withdrawal
        if(item.service_type_code === '6411'){
          let url = '/modification/withdrawal/step' + (item.receipt_step + 1) + '/' + item.receipt_no
          this.$router.push(url)
        }

        // 1012	Request abandonment
        if(item.service_type_code === '6412'){
          let url = '/modification/abandonment/step' + (item.receipt_step + 1) + '/' + item.receipt_no
          this.$router.push(url)
        }

        // 1013	Request register license
        if(item.service_type_code === '6413'){
          let url = '/modification/registerlicense/step' + (item.receipt_step + 1) + '/' + item.receipt_no
          this.$router.push(url)
        }

        // 1014	Request modify license
        if(item.service_type_code === '6414'){
          let url = '/modification/modifylicense/step' + (item.receipt_step + 1) + '/' + item.receipt_no
          this.$router.push(url)
        }

        // 1015	Request appeal
        if(item.service_type_code === '6415'){
          let url = '/appeal/step' + (item.receipt_step + 1) + '/' + item.receipt_no
          this.$router.push(url)
        }

        // 1016	Request opposite
        if(item.service_type_code === '6416'){
          let url = '/opposition/step' + (item.receipt_step + 1) + '/' + item.receipt_no
          this.$router.push(url)
        }

        // 1017	Research service
        if(item.service_type_code === '6417'){
          let url = '/public/research/step' + item.receipt_step + '/' + item.receipt_no
          this.$router.push(url)
        }

        // 1018	Writing and printing
        if(item.service_type_code === '6418'){
          let url = '/public/writingandprinting/step' + (item.receipt_step + 1) + '/' + item.receipt_no
          this.$router.push(url)
        }

        // 1019	Translation and audit
        if(item.service_type_code === '6419'){
          let url = '/public/translationandaudit/step' + (item.receipt_step + 1) + '/' + item.receipt_no
          this.$router.push(url)
        }

        // 1020	Certified copy service
        if(item.service_type_code === '6420'){
          let url = '/public/certifiedcopyservice/step' + (item.receipt_step + 1) + '/' + item.receipt_no
          this.$router.push(url)
        }

        // 1021	In person meeting
        if(item.service_type_code === '6421'){
          let url = '/public/inpersonmeeting/step' + (item.receipt_step + 1) + '/' + item.receipt_no
          this.$router.push(url)
        }

        // 1022	eServcie conversion
        if(item.service_type_code === '6422'){
          let url = '/eserviceconversion/step' + (item.receipt_step + 1) + '/' + item.receipt_no
          this.$router.push(url)
        }

        // 1024 Restoration
        if(item.service_type_code === '6427'){
          let url = '/maintenance/restoration/step' + (item.receipt_step + 1) + '/' + item.receipt_no
          this.$router.push(url)
        }

        if (item.service_type_code === '6441' ||
            item.service_type_code === '6442' ||
            item.service_type_code === '6443' ||
            item.service_type_code === '6444' ||
            item.service_type_code === '6445') {

          let url = '/modification/document/step' + item.receipt_step + '/' + item.receipt_no
          this.$router.push(url)
        }
      }else{
        //상세보기로 넘어가기 전에 쿼리스트링을 만들어준다.
        let url = ''
        let qryStr = '?'
        qryStr += 'search_service_type_code=' + this.search_service_type_code
        qryStr += '&search_receipt_no=' + this.search_receipt_no
        qryStr += '&search_application_no=' + this.search_application_no
        qryStr += '&search_receipt_status_type_code=' + this.search_receipt_status_type_code
        qryStr += '&search_request_date=' + this.search_request_date
        qryStr += '&page='+ this.options.page
        qryStr += '&page_size='+ this.options.itemsPerPage
        qryStr += '&sort_by='+ ((this.options.sortBy.length > 0) ? this.options.sortBy[0] : '')
        qryStr += '&sort_desc='+ ((this.options.sortDesc.length > 0) ? this.options.sortDesc[0] : '')

        //Draft(4301)가 아닐경우만 상세보기 페이지로 넘어간다.
        //상세 보기도 다양한 종류가 있으므로 각 request_service_code 에 따라 다른 페이지로 가게 하는게 맞을것 같음...

        // 아래 url 경로 파일에 예제 달아놓음.
        // 1001 Temporary protection
        if(item.service_type_code === '6401'){
          url = '/myrequest/view/temporaryprotection/'+item.receipt_no
        }

        // 1002 Patent
        if(item.service_type_code === '6402'){
          url = '/myrequest/view/patent/'+item.receipt_no
        }

        // 1003 Utility model
        if(item.service_type_code === '6403'){
          url = '/myrequest/view/utilitymodel/'+item.receipt_no
        }

        // 1004 IC topography
        if(item.service_type_code === '6404'){
          url = '/myrequest/view/ictopography/'+item.receipt_no
        }

        // 1005	Submit missing document
        if(item.service_type_code === '6405'){
          url = '/myrequest/view/submitmissingdocument/'+item.receipt_no
        }

        // 1006	Submit amendment
        if(item.service_type_code === '6406'){
          url = '/myrequest/view/submitamendment/'+item.receipt_no
        }

        // 1007	Request voluntary amendment
        if(item.service_type_code === '6407'){
          url = '/myrequest/view/voluntaryamendment/'+item.receipt_no
        }

        // 1008	Request change name or address
        if(item.service_type_code === '6408'){
          url = '/myrequest/view/changenameaddress/'+item.receipt_no
        }

        // 1009	Request change ownership
        if(item.service_type_code === '6409'){
          url = '/myrequest/view/changeownership/'+item.receipt_no
        }

        // 1010	Request assign or change agent
        if(item.service_type_code === '6410'){
          url = '/myrequest/view/assignchangeagent/'+item.receipt_no
        }

        // 1011	Request withdrawal
        if(item.service_type_code === '6411'){
          url = '/myrequest/view/withdrawal/'+item.receipt_no
        }


        // 1012	Request abandonment
        if(item.service_type_code === '6412'){
          url = '/myrequest/view/abandonment/'+item.receipt_no
        }

        // 1013	Request register license
        if(item.service_type_code === '6413'){
          url = '/myrequest/view/registerlicense/'+item.receipt_no
        }

        // 1014	Request modify license
        if(item.service_type_code === '6414'){
          url = '/myrequest/view/modifylicense/'+item.receipt_no
        }

        // 1015	Request appeal
        if(item.service_type_code === '6415'){
          url = '/myrequest/view/requestappeal/'+item.receipt_no
        }

        // 1016	Request opposite
        if(item.service_type_code === '6416'){
          url = '/myrequest/view/opposition/' + item.receipt_no
        }

        // 1017	Research service
        if(item.service_type_code === '6417'){
          url = '/myrequest/view/researchservice/' + item.receipt_no
        }

        // 1018	Writing and printing
        if(item.service_type_code === '6418'){
          url = '/myrequest/view/writingandprinting/' + item.receipt_no
        }

        // 1019	Translation and audit
        if(item.service_type_code === '6419'){
          url = '/myrequest/view/translationandaudit/' + item.receipt_no
        }

        // 1020	Certified copy service
        if(item.service_type_code === '6420'){
          url = '/myrequest/view/certifiedcopyservice/' + item.receipt_no
        }

        // 1021	In person meeting
        if(item.service_type_code === '6421'){
          url = '/myrequest/view/inpersonmeeting/' + item.receipt_no
        }

        // 1022	eServcie conversion
        if(item.service_type_code === '6422'){
          url = '/myrequest/view/eserviceconversion/' + item.receipt_no
        }

        // 1024 Restoration
        if(item.service_type_code === '6427'){
          url = '/myrequest/view/restoration/'+item.receipt_no
        }

        if (item.service_type_code === '6441' ||
            item.service_type_code === '6442' ||
            item.service_type_code === '6443' ||
            item.service_type_code === '6444' ||
            item.service_type_code === '6445') {

          url = '/myrequest/view/document/'+ item.receipt_no
        }

        if (url !== '') {
          this.$router.push(url + qryStr)
        }
      }
    },

    formatDate (date) {
      if (!date) return ''
      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },

    getColor (colorbadge) {
      if (colorbadge === '4302') return '#333'
      else if (colorbadge === '4303') return '#c1c1c1'
      else if (colorbadge === '4304') return '#99bc44'
      else if (colorbadge === '4308') return '#a01c2a'
      else if (colorbadge === '4305' || colorbadge === '4307') return '#2a58ad'
      else if (colorbadge === '4306' || colorbadge === '4309' || colorbadge === '4310') return '#01c3ff'
      else return '#1f94a6'
    }
  },
}
</script>
